import { AnyObject } from "../interfaces/AnyObject";
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const baseRoutingOrdersRoute = `${baseUrl}/routings-api`;

export const getRousingPlaneSearchRoute = (searchParams: AnyObject) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing/search`,
    searchParams,
  });

export const getRousingPlaneRoute = (
  tcOfferingItemId: number,
  searchParams: AnyObject | undefined
) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing/${tcOfferingItemId}`,
    searchParams,
  });

export const getRousingPlaneVersionsRoute = (tcOfferingItemId) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing/${tcOfferingItemId}/versions`,
  });

export const getSupplierOfferingssRoute = (searchParams: AnyObject) =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/supplier-offerings`,
    searchParams,
  });

export const getCreateRousingPlaneRoute = () =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders`,
  });

export const getUpdateRousingPlaneRoute = () =>
  buildUrl({
    url: `${baseRoutingOrdersRoute}/routing-orders`,
  });
